import { TenantInvoice } from '../../types/invoice'

export const formatInvoiceLocation = (location: string): string => {
    const trimmed = location.trim()
    if (!trimmed) {
        return location
    }
    const segments = trimmed.split('/').filter(Boolean)
    if (segments.length === 0) {
        return trimmed
    }
    return segments[segments.length - 1]
}

export const getInvoiceServiceName = (invoice: TenantInvoice): string => {
    if (invoice.service?.name) {
        return invoice.service.name
    }
    const items = invoice.items ?? []
    return items[0]?.service ?? 'Invoice'
}

export const getLineItemLabel = (count: number): string => {
    return `${count} line item${count === 1 ? '' : 's'}`
}
